/* DISAYNER · ajout direct depuis l'upsell du tiroir panier (même mécanique que app.js) */
(function () {
  function parse(html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-lam-quick-add]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]'); var idEl = form.querySelector('[name=id]');
    if (!idEl || !idEl.value) return;
    if (btn) btn.disabled = true;
    var fd = new FormData();
    fd.append('id', idEl.value); fd.append('quantity', 1);
    fd.append('sections', 'cart-drawer,cart-bubble'); fd.append('sections_url', window.location.pathname);
    var url = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (btn) btn.disabled = false; return; }
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && res.sections && res.sections['cart-drawer']) {
          var target = drawer.querySelector('.cart-drawer') || drawer;
          var html = parse(res.sections['cart-drawer'], '.cart-drawer');
          if (html !== null) target.innerHTML = html;
          if (drawer.notesToggle) drawer.notesToggle();
          if (drawer.removeProductEvent) drawer.removeProductEvent();
          drawer.classList.add('active'); document.body.classList.add('open-cart'); document.body.classList.add('open-cc');
        }
        var bubble = document.getElementById('cart-drawer-toggle');
        if (bubble && res.sections && res.sections['cart-bubble']) {
          var cnt = bubble.querySelector('.thb-item-count'); var h = parse(res.sections['cart-bubble'], '.thb-item-count');
          if (cnt && h !== null) cnt.innerHTML = h;
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res } }));
      })
      .catch(function () { if (btn) btn.disabled = false; });
  });
})();

/* pastilles couleur : filtre les tailles du menu déroulant */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.lam-swatch') : null;
    if (!sw) return;
    var form = sw.closest('form[data-lam-quick-add]'); if (!form) return;
    var dataEl = form.querySelector('.lam-upsell__data'); var sel = form.querySelector('select[name=id]');
    if (!dataEl || !sel) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var lang = (document.documentElement.lang || '').toLowerCase();
    var outLbl = lang.indexOf('nl') === 0 ? 'uitverkocht' : (lang.indexOf('en') === 0 ? 'sold out' : 'épuisé');
    form.querySelectorAll('.lam-swatch').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
    var color = sw.dataset.color; sel.innerHTML = '';
    var firstOk = null;
    variants.filter(function (v) { return v.c === color; }).forEach(function (v) {
      var o = document.createElement('option'); o.value = v.id; o.textContent = v.l + (v.a ? '' : ' (' + outLbl + ')');
      if (!v.a) o.disabled = true; else if (firstOk === null) firstOk = v.id;
      sel.appendChild(o);
    });
    if (firstOk !== null) sel.value = firstOk;
    var img = sw.closest('.lam-upsell__card').querySelector('.lam-upsell__img img');
    var withImg = variants.filter(function (v) { return v.c === color && v.i; })[0];
    if (img && withImg) { img.removeAttribute('srcset'); img.src = withImg.i; }
  });
})();

/* DISAYNER · confirmation avant retrait d'un article (tiroir + page panier, demande client 10/09) */
(function () {
  var L = (document.documentElement.lang || 'fr').slice(0, 2);
  var T = L === 'nl' ? { q: 'Dit artikel uit je winkelmand verwijderen?', ok: 'Verwijderen', ko: 'Annuleren' }
        : L === 'en' ? { q: 'Remove this item from your cart?', ok: 'Remove', ko: 'Cancel' }
        : { q: 'Retirer cet article du panier ?', ok: 'Retirer', ko: 'Annuler' };
  var box = null;
  function close() { if (box) { box.remove(); box = null; document.removeEventListener('keydown', onKey); } }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function dialog(onOk) {
    close();
    box = document.createElement('div');
    box.className = 'lam-confirm';
    box.innerHTML = '<div class="lam-confirm__box" role="alertdialog" aria-label="' + T.q + '">'
      + '<p class="lam-confirm__text">' + T.q + '</p>'
      + '<div class="lam-confirm__actions">'
      + '<button type="button" class="lam-confirm__ok">' + T.ok + '</button>'
      + '<button type="button" class="lam-confirm__cancel">' + T.ko + '</button>'
      + '</div></div>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.querySelector('.lam-confirm__cancel').addEventListener('click', close);
    box.querySelector('.lam-confirm__ok').addEventListener('click', function () { close(); onOk(); });
    document.addEventListener('keydown', onKey);
    box.querySelector('.lam-confirm__cancel').focus();
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('a.remove');
    if (!rm) return;
    if (rm.dataset.lamConfirmed) { delete rm.dataset.lamConfirmed; return; }
    e.preventDefault();
    e.stopPropagation();
    dialog(function () { rm.dataset.lamConfirmed = '1'; rm.click(); });
  }, true);
})();


/* DISAYNER 10/10 · remise première commande appliquée automatiquement au panier (code PREMIERECOMMANDE).
   Le tiroir signale par [data-lam-fo-apply] un panier sans code, cliente non connectée ou sans commande.
   Shopify valide l'éligibilité au paiement une fois l'e-mail saisi et retire le code sinon. */
(function () {
  var busy = false, tries = 0, timer = null;
  function parse(html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; }
  function render(res) {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || !res || !res.sections || !res.sections['cart-drawer']) return;
    var html = parse(res.sections['cart-drawer'], '.cart-drawer');
    if (html === null) return;
    var target = drawer.querySelector('.cart-drawer') || drawer;
    target.innerHTML = html;
    if (drawer.notesToggle) drawer.notesToggle();
    if (drawer.removeProductEvent) drawer.removeProductEvent();
  }
  function apply() {
    var flag = document.querySelector('#Cart-Drawer [data-lam-fo-apply]');
    if (!flag || busy || tries >= 2) return;
    busy = true; tries++;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: flag.dataset.code, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 250); }
  function init() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('cart:item-added', function () { tries = 0; schedule(); });
})();

/* DISAYNER 29/10 · date de livraison estimée et compte à rebours vers l'heure limite d'expédition */
(function () {
  if (!window.customElements || customElements.get('lam-eta')) return;
  var CUTOFF = 16 * 60;  /* dernière commande expédiée le jour même : 16 h, heure de Bruxelles (équipe, 28/10) */
  var MIN = 2, MAX = 5;  /* livraison 2 à 5 jours ouvrés après l'expédition */
  /* jours fériés belges : ni expédition ni livraison. À prolonger avant fin 2027. */
  var OFF = ['2026-11-11', '2026-12-25', '2027-01-01', '2027-03-29', '2027-05-06', '2027-05-17', '2027-07-21', '2027-11-01', '2027-11-11', '2027-12-25'];
  var L = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var LOC = L === 'nl' ? 'nl-BE' : (L === 'en' ? 'en-GB' : 'fr-BE');
  var T = L === 'nl' ? {
      left: function (t) { return 'Bestel binnen <b>' + t + '</b> en je bestelling vertrekt vandaag.'; },
      tomorrow: 'Bestel nu, je bestelling vertrekt morgen.',
      on: function (d) { return 'Bestel nu, je bestelling vertrekt ' + d + '.'; },
      eta: function (a, b) { return 'Verwachte levering tussen <b>' + a + '</b> en <b>' + b + '</b>.'; },
      h: '&nbsp;u', m: '&nbsp;min'
    } : L === 'en' ? {
      left: function (t) { return 'Order within <b>' + t + '</b> and it ships today.'; },
      tomorrow: 'Order now and it ships tomorrow.',
      on: function (d) { return 'Order now and it ships on ' + d + '.'; },
      eta: function (a, b) { return 'Estimated delivery between <b>' + a + '</b> and <b>' + b + '</b>.'; },
      h: '&nbsp;h', m: '&nbsp;min'
    } : {
      left: function (t) { return 'Commandez dans les <b>' + t + '</b>, votre commande part aujourd\'hui.'; },
      tomorrow: 'Commandez maintenant, votre commande part demain.',
      on: function (d) { return 'Commandez maintenant, votre commande part ' + d + '.'; },
      eta: function (a, b) { return 'Livraison estimée entre le <b>' + a + '</b> et le <b>' + b + '</b>.'; },
      h: '&nbsp;h', m: '&nbsp;min'
    };
  /* date du jour et heure à Bruxelles, quel que soit le fuseau de la cliente ; les dates sont des minuits UTC */
  function now() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), min: (+p.hour % 24) * 60 + (+p.minute) };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function open(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && OFF.indexOf(iso(d)) < 0; }
  function next(d) { var n = new Date(d.getTime()); do { n.setUTCDate(n.getUTCDate() + 1); } while (!open(n)); return n; }
  function plus(d, k) { var n = d; for (var i = 0; i < k; i++) n = next(n); return n; }
  function fmt(d, opts) { opts.timeZone = 'UTC'; return new Intl.DateTimeFormat(LOC, opts).format(d); }
  function paint(el) {
    try {
      var t = now(), line;
      var ship = open(t.d) && t.min < CUTOFF ? t.d : next(t.d);
      if (ship === t.d) {
        var left = CUTOFF - t.min, h = Math.floor(left / 60), m = left % 60;
        line = T.left((h ? h + T.h : '') + (h && m ? ' ' : '') + (m ? m + T.m : ''));
      } else if (iso(ship) === iso(new Date(t.d.getTime() + 864e5))) {
        line = T.tomorrow;
      } else {
        line = T.on(fmt(ship, { weekday: 'long' }));
      }
      var a = plus(ship, MIN), b = plus(ship, MAX);
      var same = a.getUTCMonth() === b.getUTCMonth();
      var da = fmt(a, same ? { weekday: 'long', day: 'numeric' } : { weekday: 'long', day: 'numeric', month: 'long' });
      var db = fmt(b, { weekday: 'long', day: 'numeric', month: 'long' });
      el.innerHTML = '<span class="lam-eta__cut">' + line + '</span><span class="lam-eta__date">' + T.eta(da, db) + '</span>';
      el.classList.add('is-ready');
    } catch (e) {}
  }
  customElements.define('lam-eta', class extends HTMLElement { connectedCallback() { paint(this); } });
  setInterval(function () { document.querySelectorAll('lam-eta').forEach(paint); }, 20000);
})();
/* fin DISAYNER 29/10 · date de livraison */

/* DISAYNER 29/10 · carnet offert dès 150 € : le tiroir signale par [data-lam-gift] l'ajout, le retrait ou la remise à 1 (cadeau_offert.py) */
(function () {
  var busy = false, fails = 0, done = 0, waits = 0, timer = null;
  function parse(html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; }
  function render(res) {
    if (!res || !res.sections) return;
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && res.sections['cart-drawer']) {
      var html = parse(res.sections['cart-drawer'], '.cart-drawer');
      if (html !== null) {
        (drawer.querySelector('.cart-drawer') || drawer).innerHTML = html;
        if (drawer.notesToggle) drawer.notesToggle();
        if (drawer.removeProductEvent) drawer.removeProductEvent();
      }
    }
    var bubble = document.getElementById('cart-drawer-toggle');
    if (bubble && res.sections['cart-bubble']) {
      var cnt = bubble.querySelector('.thb-item-count'), h = parse(res.sections['cart-bubble'], '.thb-item-count');
      if (cnt && h !== null) cnt.innerHTML = h;
    }
  }
  function run() {
    var f = document.querySelector('#Cart-Drawer [data-lam-gift]');
    if (!f || busy || fails >= 3 || done >= 8) return;
    /* la remise première commande passe d'abord : elle change le total, donc le droit au carnet */
    if (document.querySelector('#Cart-Drawer [data-lam-fo-apply]') && waits < 4) { waits++; schedule(700); return; }
    busy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var body = f.dataset.key ? { id: f.dataset.key, quantity: +f.dataset.qty } : { items: [{ id: +f.dataset.id, quantity: 1 }] };
    body.sections = 'cart-drawer,cart-bubble';
    body.sections_url = window.location.pathname;
    fetch(root + (f.dataset.key ? 'cart/change.js' : 'cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (res) { done++; fails = 0; render(res); })
      .catch(function () { fails++; })
      .then(function () { busy = false; });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(run, ms || 300); }
  function init() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    new MutationObserver(function () { schedule(); }).observe(drawer, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('cart:item-added', function () { fails = 0; waits = 0; schedule(); });
})();
/* fin DISAYNER 29/10 · carnet offert */

/* DISAYNER 01/11 · clic Google Ads gardé dans le panier (attributs cachés) */
(function () {
  var K = 'lamGclid', MAX = 90 * 864e5, p = new URLSearchParams(location.search), hit = null;
  ['gclid', 'gbraid', 'wbraid'].some(function (k) { var v = p.get(k); if (v) { hit = { id: v, t: k, ts: Date.now() }; return true; } });
  function cp() { return window.Shopify && Shopify.customerPrivacy; }
  function ok() { try { return !!(cp() && cp().marketingAllowed && cp().marketingAllowed()); } catch (e) { return false; } }
  function read() { try { var s = JSON.parse(localStorage.getItem(K) || 'null'); return s && Date.now() - s.ts < MAX ? s : null; } catch (e) { return null; } }
  function run() {
    if (!ok()) return;
    var s = hit || read();
    if (!s) return;
    if (hit) { try { localStorage.setItem(K, JSON.stringify(hit)); } catch (e) {} }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var a = cart.attributes || {};
      if (a._gclid === s.id) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _gclid: s.id, _gclid_type: s.t, _gclid_date: new Date(s.ts).toISOString(), _ads_consent: 'oui' } }) });
    }).catch(function () {});
  }
  function start() {
    document.addEventListener('visitorConsentCollected', run);
    if (cp()) return run();
    if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) run(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* fin DISAYNER 01/11 · clic Google Ads */

/* DISAYNER 02/11 minuteur panier 30 min */
(function () {
  if (!window.customElements || customElements.get('lam-cart-timer')) return;
  var K = 'lamCartT0', D = 30 * 60 * 1000;
  var T = { fr: 'Votre panier est réservé pendant', en: 'Your cart is reserved for', nl: 'Je winkelmandje is gereserveerd voor' };
  function get() { try { return parseInt(localStorage.getItem(K), 10) || 0; } catch (e) { return 0; } }
  function set(v) { try { v ? localStorage.setItem(K, String(v)) : localStorage.removeItem(K); } catch (e) {} }
  customElements.define('lam-cart-timer', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-empty')) { set(0); return; }
      var t0 = get(); if (!t0) { t0 = Date.now(); set(t0); }
      var l = (this.getAttribute('data-l') || 'fr').slice(0, 2), lbl = T[l] || T.fr, self = this;
      function tick() {
        var r = D - (Date.now() - t0);
        if (r <= 0) { self.classList.remove('is-on'); clearInterval(self._i); return; }
        var m = Math.floor(r / 60000), s = Math.floor(r % 60000 / 1000);
        self.innerHTML = lbl + ' <b>' + m + ':' + (s < 10 ? '0' : '') + s + '</b>';
        self.classList.add('is-on');
      }
      tick(); this._i = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this._i); }
  });
})();
/* fin DISAYNER 02/11 minuteur panier */
